import AxiosControl from '../../context/axios/AxiosControl'
const Axios = AxiosControl()

export const getSepaLogs = () => async (dispatch) => {
    dispatch({
        type: 'SEPALOGS_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/logs/sepalogs', {
            headers: { auth: sessionStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'SEPALOGS_GETALL_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'SEPALOGS_NOT_LOADING'
        })
    }
}

export const getSepaLogsByClub = (club) => async (dispatch) => {
    dispatch({
        type: 'SEPALOGS_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/logs/sepalogsbyclub/'+ club, {
            headers: { auth: sessionStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'SEPALOGS_GETALL_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'SEPALOGS_NOT_LOADING'
        })
    }
}

